import type { PathLookupPassingTraffic } from '@ipfabric/utils';
import classNames from 'classnames';
import { useLocale } from 'containers/App/LocaleContext';
import type { FC } from 'react';
import type { AppTranslations } from 'translations/translations';
import { getPassingTrafficResult } from '../helpers/getPassingTrafficResult';

interface Props {
  passingTraffic: PathLookupPassingTraffic | null;
  expectedPassingTraffic: PathLookupPassingTraffic | null;
}

const getMessage = (
  msg: AppTranslations,
  passingTraffic: PathLookupPassingTraffic | null,
  expectedPassingTraffic: PathLookupPassingTraffic | null,
): string => {
  const {
    canvasGraph: {
      graphSidePanel: {
        pathlookup: {
          pathVerification: { detectedState },
        },
      },
    },
  } = msg;
  const passingTrafficResult = getPassingTrafficResult(
    passingTraffic,
    expectedPassingTraffic,
  );

  return detectedState[passingTrafficResult];
};

export const PathDetectedState: FC<Props> = (props) => {
  const msg = useLocale();

  return (
    <div
      className={classNames(
        'graph-path-detected-state',
        props.passingTraffic === props.expectedPassingTraffic &&
          props.passingTraffic !== 'error' &&
          props.expectedPassingTraffic !== null &&
          'graph-path-detected-state--pass',
        props.passingTraffic !== props.expectedPassingTraffic &&
          props.expectedPassingTraffic !== null &&
          props.passingTraffic !== 'error' &&
          'graph-path-detected-state--fail',
      )}
    >
      {props.passingTraffic &&
        props.expectedPassingTraffic &&
        getMessage(msg, props.passingTraffic, props.expectedPassingTraffic)}
    </div>
  );
};
